import { useMutation, useQueryClient } from "@tanstack/react-query";

import { processResponse } from "Infrastructure/Api/ApiUtils";
import { putUserNotificationsSeen } from "Notifications/Api/notificationApi";
import { NOTIFICATIONS_QUERY_KEYS } from "Notifications/Api/Queries/queryKeys";

export function useMarkAsSeenMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse(() => putUserNotificationsSeen()),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: NOTIFICATIONS_QUERY_KEYS.unseenCount(),
      });
    },
  });
}
